/**
 * Shared checkmark icon for filter active states.
 */

interface CheckIconProps {
  size?: number;
  className?: string;
}

export function CheckIcon({ size = 12, className }: CheckIconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}
